export var GameState;
(function (GameState) {
    GameState[GameState["playing"] = 0] = "playing";
    GameState[GameState["won"] = 1] = "won";
    GameState[GameState["lost"] = 2] = "lost";
})(GameState || (GameState = {}));
export var MatchState;
(function (MatchState) {
    MatchState[MatchState["normal"] = 0] = "normal";
    MatchState[MatchState["nomatch"] = 1] = "nomatch";
    MatchState[MatchState["exists"] = 2] = "exists";
    MatchState[MatchState["matches"] = 3] = "matches";
    MatchState[MatchState["invalidWord"] = 4] = "invalidWord";
})(MatchState || (MatchState = {}));
export var GameType;
(function (GameType) {
    GameType[GameType["daily"] = 0] = "daily";
    GameType[GameType["practice"] = 1] = "practice";
})(GameType || (GameType = {}));
